// This loads javascript for this block on the frontend.
import { createRoot } from "@wordpress/element";
import FloatingButton from "./components/floating-button";

const buttonDiv = document.querySelector(".wp-block-ms-quote-block");
if (buttonDiv) {
  createRoot(buttonDiv).render(<FloatingButton />);
}
